import { SetStateAction } from "react";

// --- handle clear error ---
const handleClearError = (
  setterError: React.Dispatch<SetStateAction<any>>,
  key: string,
) => {
  setterError((prev: any) => {
    const next = { ...prev };
    delete next[key];
    return next;
  });
};

export default handleClearError;
